module.exports = __webpack_public_path__ + "static/TT-Testfit_Floor22-a53569f930d59ce912104cbe8a2af46a.jpg";